import { RankCard } from '@/shared/components/RankCard';
import { getRankPreset } from '@/shared/components/RankCard/rankCardPresets';
import type { LeaderboardEntry } from 'shared-types';

interface LeaderboardListProps {
  entries: LeaderboardEntry[];
  currentUserPseudo?: string;
}

export function LeaderboardList({ entries, currentUserPseudo }: LeaderboardListProps) {
  if (entries.length === 0) {
    return (
      <div className="flex items-center justify-center py-8">
        <span
          className="font-mind-boggle text-center opacity-50"
          style={{ color: '#1A3A5C', fontSize: 'clamp(0.75rem, 3vw, 1rem)' }}
        >
          —
        </span>
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-2">
      {entries.map((entry) => (
        <RankCard
          key={`${String(entry.rank)}-${entry.pseudo}`}
          rank={entry.rank}
          username={entry.pseudo}
          score={entry.points}
          background={getRankPreset(entry.rank)}
          isHighlighted={entry.pseudo === currentUserPseudo}
        />
      ))}
    </div>
  );
}

export default LeaderboardList;
